export enum NotificationActions {
    POSTED_NEW_COMMENT = 'Публикува коментар',
    EDITED_COMMENT = 'Редактира коментар',
    NEW_COMMENT = 'Нов коментар',
    DELETED_COMMENT = 'Изтри коментар',
    POSTED_NEW_RECIPE = 'Публикува рецепта',
    EDITED_RECIPE = 'Редактира рецепта',
    NEW_RECIPE = 'Нова рецепта',
    DELETED_RECIPE = 'Изтри рецепта',
    NEW_USER = 'Нов потребител',
    REGISTERED = 'Се регистрира',
}
